module.exports = __webpack_public_path__ + "static/media/sg11tj538.493ce0cf.png";